import React from "react";
import Box from "@mui/material/Box";
import {useSelector} from "react-redux";
import ModuleLoader from "../module-loader";
import {moduleConfigsSelector} from "../../state/module-configs/moduleConfigsSelectors";

const ModulesPlaceholder = ({id: placeholderId, moduleFallback, DefaultComponent, sx, style, ...props}) => {
  const moduleConfigs = useSelector(moduleConfigsSelector);
  return (moduleConfigs.placeholders?.[placeholderId] || []).length > 0 ? (
    <Box id={placeholderId} sx={sx} style={style}>
      {moduleConfigs.placeholders[placeholderId].map((module, idx) => (
        <Box key={idx} id={`${placeholderId}__${module.id}`}>
          <ModuleLoader
            id={module.id}
            component={module.component}
            fallback={moduleFallback ?? module.fallback}
            {...props}
          />
        </Box>
      ))}
    </Box>
  ) : DefaultComponent ? (
    DefaultComponent
  ) : null;
};

export default ModulesPlaceholder;
